import React from 'react';
import { Button, Input, Modal } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import WidgetMessage from '../../../widget/WidgetMessage';

const maxCount = 5;

class JobSelectModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 0,
      secondIndex: 0,
      codes: props.selectedCodes || [],
      items: props.selectedItems || [],
    };
  }

  componentDidUpdate(prevProps) {
    const { selectedCodes, selectedItems, visible } = this.props;
    // 仅在弹窗从关闭变为打开时重置为父级传入的已选项；
    // 弹窗打开后父级传入新数组引用不清空用户的临时选择，关闭时也不重置。
    if (!prevProps.visible && visible) {
      this.setState({
        codes: selectedCodes || [],
        items: selectedItems || [],
        tabIndex: 0,
        secondIndex: 0,
      });
    }
  }

  isLeaf = (item, thirdList) => {
    const { thirdLevelOnly = true, single } = this.props;
    if (thirdLevelOnly || single) {
      return Array.isArray(thirdList) && thirdList.some((node) => node.code === item.code);
    }
    if (!item || !Array.isArray(item.children) || item.children.length === 0) return true;
    return false;
  };

  toggleSelect = (item) => {
    const { single } = this.props;
    const { codes, items } = this.state;
    const { secondList, thirdList } = this.getDerived();

    if (!this.isLeaf(item, thirdList)) {
      // 二级节点：只切换二级 tab，不进入已选区
      const idx = secondList.findIndex((node) => node.code === item.code);
      if (idx >= 0) this.setState({ secondIndex: idx });
      return;
    }

    if (single) {
      const sameCode = codes[0] === item.code;
      this.setState({
        codes: sameCode ? [] : [item.code],
        items: sameCode ? [] : [item],
      });
      return;
    }

    if (codes.includes(item.code)) {
      this.setState({
        codes: codes.filter((code) => code !== item.code),
        items: items.filter((selected) => selected.code !== item.code),
      });
      return;
    }

    if (codes.length >= maxCount) {
      WidgetMessage.warning('最多只可选5个职位！');
      return;
    }

    this.setState({
      codes: [...codes, item.code],
      items: [...items, item],
    });
  };

  removeSelected = (item) => {
    const { single } = this.props;
    const { codes, items } = this.state;
    if (single) {
      this.setState({ codes: [], items: [] });
      return;
    }
    this.setState({
      codes: codes.filter((code) => code !== item.code),
      items: items.filter((selected) => selected.code !== item.code),
    });
  };

  getDerived() {
    const { jobTypeList = [] } = this.props;
    const { tabIndex, secondIndex } = this.state;
    const first = jobTypeList[tabIndex];
    const secondList = first && first.children ? first.children : [];
    const second = secondList[secondIndex];
    const thirdList = (second && second.children) || [];
    return { first, secondList, second, thirdList };
  }

  render() {
    const {
      visible,
      jobTypeList = [],
      onSearch = () => {},
      onCancel,
      onConfirm,
      single,
      thirdLevelOnly = true,
    } = this.props;
    const { tabIndex, secondIndex, codes, items } = this.state;
    const { secondList, thirdList } = this.getDerived();

    const confirmItems = single ? items.slice(0, 1) : items;

    return (
      <Modal
        title={single ? '岗位类型选择' : '期望岗位选择'}
        visible={visible}
        centered
        width={890}
        bodyStyle={{ maxHeight: 420, overflow: 'auto', padding: '12px 20px' }}
        wrapClassName="resume-new-selector-modal resume-new-selector-modal-compact"
        onCancel={onCancel}
        footer={<Button type="primary" onClick={() => onConfirm(confirmItems)}>确认</Button>}
        getContainer={false}
      >
        <div className="resume-new-selector-search"><Input placeholder="搜索岗位" onChange={(event) => onSearch(event.target.value)} /></div>
        <div className="resume-new-selector-body">
          <ul className="resume-new-selector-left">
            {jobTypeList.map((item, index) => (
              <li
                key={item.code || index}
                className={tabIndex === index ? 'is-active' : ''}
                onClick={() => { this.setState({ tabIndex: index, secondIndex: 0 }); }}
              >
                {item.name}
              </li>
            ))}
          </ul>
          <ul className="resume-new-selector-middle">
            {secondList.map((item, index) => {
              const active = secondIndex === index || codes.includes(item.code);
              const clickable = !thirdLevelOnly && Array.isArray(item.children) && item.children.length > 0;
              return (
                <li
                  key={item.code || index}
                  className={active ? 'is-active' : ''}
                  onClick={() => {
                    if (clickable) {
                      this.setState({ secondIndex: index });
                      return;
                    }
                    this.toggleSelect(item);
                  }}
                >
                  {item.name}
                </li>
              );
            })}
          </ul>
          <div className="resume-new-selector-right">
            {thirdList.length === 0 ? (
              <div className="resume-new-selector-empty">请先选择二级分类</div>
            ) : (
              thirdList.map((item) => (
                <button
                  type="button"
                  key={item.code}
                  className={codes.includes(item.code) ? 'is-active' : ''}
                  onClick={() => this.toggleSelect(item)}
                >
                  {item.name}
                </button>
              ))
            )}
          </div>
        </div>
        <div className="resume-new-selected">
          <div className="resume-new-selected-header">
            <span>我选择的岗位</span>
            <span>已选{items.length} / {single ? 1 : maxCount}</span>
          </div>
          <div className="resume-new-selected-tags">
            {items.length === 0 ? <span className="resume-new-selected-empty">暂未选择</span> : null}
            {items.map((item) => (
              <span key={item.code}>
                {item.name}
                <CloseOutlined onClick={() => this.removeSelected(item)} />
              </span>
            ))}
          </div>
        </div>
      </Modal>
    );
  }
}

export default JobSelectModal;
